import { render, staticRenderFns } from "./SingleBookDetail.vue?vue&type=template&id=67739284&"
import script from "./SingleBookDetail.vue?vue&type=script&lang=js&"
export * from "./SingleBookDetail.vue?vue&type=script&lang=js&"
import style0 from "./SingleBookDetail.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports